import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import firstImage from '../../../assets/images/warehouse.png';
import secondImage from '../../../assets/images/information.png';
import Trash from '../../../assets/images/trash.png';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion } from 'react-bootstrap';
import { faArrowLeft, faPaperPlane, faPaperclip, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Step, StepLabel, Stepper } from '@mui/material';
import Offline from '../../../assets/images/offline.png';
import Pack from '../../../assets/images/n_package.png';
import Docmnt from "../../../assets/images/google-docs.png";
import { toast } from 'react-toastify';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { HANDLERRDETAILS, HANDLERUPDATE, SAVECONVO } from '../../../Utils/conts.js';


const EditHandlerRecovery = () => {
    const isMounted = useRef(false);
    const [recoveryDetails, seRecoveryDetails] = useState({});
    const [formData, setFormData] = useState({
        handler_action: [
            { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }
        ],
    });
    const [recoveryAspects, setRecoveryAspects] = useState([
        { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }
    ]);

    const [allFeedback, setAllFeedback] = useState(null);
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [selectedButton, setSelectedButton] = useState('all');

    const loadDetails = async (ms, edt) => {

        try {
            const res = await withRFSToken.post(HANDLERRDETAILS, { handler_feedback_id: edt })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code === 200) {
                        if (ms === 'M') {
                            if (selectedButton == 'all') {
                                setMsgFormData({});
                                setMsgFiles([]);
                                setAllFeedback(innerData?.handlerConversation);
                                setSelectedFeedback(innerData);
                            }
                        } else {
                            if (innerData) {
                                seRecoveryDetails(innerData);

                                setFormData(innerData);
                                setRecoveryAspects(innerData.handler_action.length > 0 ? innerData.handler_action : [{ warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }])

                            }

                            if (selectedButton == 'all') {
                                // const innerData = JSON.parse(localStorage.getItem('RecoveryEdit'))
                                // console.log("🚀 ~ useEffect ~ innerData:", innerData)
                                setAllFeedback(innerData?.handlerConversation);
                                setSelectedFeedback(innerData);
                            }
                        }
                    } else { toast.error(res.data.response_msg) }


                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        const storedData = localStorage.getItem('RecoveryEdit');
        loadDetails('L', JSON.parse(storedData))
        // if (storedData) {
        //     seRecoveryDetails(JSON.parse(storedData));

        //     setFormData(JSON.parse(storedData));
        //     setRecoveryAspects(JSON.parse(storedData).handler_action.length > 0 ? JSON.parse(storedData).handler_action : [{ warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }])
        // }

        // if (selectedButton == 'all') {
        //     const collectFeedback = JSON.parse(localStorage.getItem('RecoveryEdit'))
        //     console.log("🚀 ~ useEffect ~ collectFeedback:", collectFeedback)
        //     setAllFeedback(collectFeedback?.handlerConversation);
        //     setSelectedFeedback(collectFeedback);
        // }

        isMounted.current = true;
    }, [formData]);

    // FORM
    const handleFormChange = (event) => {
        const { name, value } = event.target;

        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);
    };
    // RECOVERY ASPECTS START
    const handleAddAspect = () => {
        if (recoveryAspects.length < 5) {
            const newAspect = { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' };
            setRecoveryAspects([...recoveryAspects, newAspect]);
            setFormData(prev => ({
                ...prev,
                handler_action: [...prev.handler_action, newAspect]
            }));
        }
    };

    // Function to handle removing a specific aspect
    const handleRemoveAspect = (index) => {
        const updatedAspects = recoveryAspects.filter((_, i) => i !== index);
        setRecoveryAspects(updatedAspects);
        setFormData(prev => ({
            ...prev,
            handler_action: updatedAspects
        }));
    };

    // Function to handle input change for each row
    const handleInputChange = (index, field, value) => {
        const updatedAspects = [...recoveryAspects];
        updatedAspects[index][field] = value;

        setRecoveryAspects(updatedAspects);
        setFormData(prev => ({
            ...prev,
            handler_action: updatedAspects
        }));
    };
    // RECOVERY ASPECTS START

    // TABS START

    const handleButtonClick = (button, details) => {
        setSelectedButton(button);
        if (button == 'all') {
            setSelectedFeedback(null);
            // const collectFeedback = recoveryDetails?.stations?.flatMap(fb => fb.handlerConversation)
            const collectFeedback = JSON.parse(localStorage.getItem('RecoveryUpdate'))
            console.log("🚀 ~ handleButtonClick ~ collectFeedback:", collectFeedback)
            setAllFeedback(collectFeedback?.handlerConversation);
        } else {
            setSelectedFeedback(details);
        }
        if (button !== selectedButton) {
            setFormData({});
            setFiles([]);
        } else {

        }

    };


    //TABS END

    // IMAGE UPLOAD START
    const fileInputRef = useRef(null);
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [isTopDel, setIsTopDel] = useState(false);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);

            // Update local storage
            setFormData((prevFormData) => {
                const newFormData = { ...prevFormData, base64Files: newBase64Files };
                return newFormData;
            });
            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleDeleteImage = (index, id, type) => {
        setIsTopDel(true);
        handleDeleteFile(index);
        // setShowConfirmation(true); need to work
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    // IMAGE UPLOAD END
    // MSG IMAGE UPLOAD START
    const msgFileInputRef = useRef(null);
    const [msgShowModalUpload, setMsgShowModalUpload] = useState(false);
    const [msgselectedRowId, setMsgSelectedRowId] = useState(null);
    const [msgFiles, setMsgFiles] = useState([]);
    const [msgbase64Files, setMsgBase64Files] = useState([]);
    const [msgFormData, setMsgFormData] = useState({});

    const msgHandleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setMsgFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        msgGetBase64(droppedFiles[0]);
    };

    const msgHandleDragOver = (e) => {
        e.preventDefault();
    };

    const msgHandleDeleteFile = (index) => {
        setMsgFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        // base64Files.splice(index, 1);
        setMsgBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);

            // Update local storage
            setFormData((prevFormData) => {
                const newFormData = { ...prevFormData, base64Files: newBase64Files };
                return newFormData;
            });
            return newBase64Files;
        });
    };

    const msgHandleBrowseFiles = (e) => {
        e.preventDefault();
        msgFileInputRef.current.click();
    };

    function msgGetBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setMsgBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const msgHandleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    // setFiles(newFiles);
                    setMsgFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setMsgBase64Files(mergedBase64Files);
                    setMsgFormData((prevFormData) => {
                        const newFormData = { ...prevFormData, files: mergedBase64Files, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    // MSG IMAGE UPLOAD END

    // STEPPER START
    const [activeStep, setActiveStep] = useState(0);
    const [finishStep, setFinishStep] = useState(false);

    const steps = [
        { label: (<>Incident Information</>), icon: <img src={firstImage} /> },
        { label: (<>Message Information</>), icon: <img src={secondImage} /> },
    ];

    const handleFinish = async () => {
        const filterPrimary = formData?.attachments?.filter(file => file.primary === 1);
        const restFiles = formData?.attachments?.filter((file) => !file.primary || file.primary !== 1);
        const transformedData = {
            ...formData,
            warehouse_check_log: formData.handler_action.map(aspect => aspect.warehouse_check_date),
            contact_agent_check_log: formData.handler_action.map(aspect => aspect.contacted_agent_date),
            service_recovery_id: recoveryDetails.service_recovery_id,
            handler_feedback_id: recoveryDetails.handler_feedback_id,
            files: [
                ...(formData.files || []),
                ...filterPrimary.map((file) => ({ id: file.id, primary: file.primary })),
                ...restFiles.map((file) => ({ id: file.id, primary: 0 })),
            ]
        };
        // console.log('transformedData', transformedData);
        try {
            const res = await withRFSToken.post(HANDLERUPDATE, transformedData)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);

                        const ddd = JSON.parse(localStorage.getItem('EditFrom'));
                        if (ddd === 'UR') {
                            window.location.href = '/UpdateRecovery';
                        } else if (ddd === 'SR') {
                            window.location.href = '/ServiceRecovery';
                        } else {
                            window.location.href = '/HandlerRecovery';
                        }
                        // setTimeout(() => {
                        //     window.location.href = '/HandlerRecovery';
                        // }, 1000);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleStepClick = async () => {
    }
    // STEPPER END
    const handleBack = () => {
        const ddd = JSON.parse(localStorage.getItem('EditFrom'));
        if (ddd === 'UR') {
            window.location.href = '/UpdateRecovery';
        } else if (ddd === 'SR') {
            window.location.href = '/ServiceRecovery';
        } else {
            window.location.href = '/HandlerRecovery';
        }
    }

    // image select
    const [selectedKeys, setSelectedKeys] = useState([]);

    const handleImageSelect = (key, data) => {
        console.log("🚀 ~ handleImageSelect ~ data:", data)

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });
                // setFiles((prevFiles) =>
                //     prevFiles.map((file, index) =>
                //         index === key
                //             ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                //             : file // Leave other files unchanged
                //     )
                // );
                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (formData.attachments) {
            if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.attachments.map((file, index) => {
                        if (file.id === data.id) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        attachments: updatedFiles,
                    };
                });
            }
        }
        // if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

        //     setEditFiles((prevFiles) =>
        //         prevFiles.map((file) =>
        //             file.id === data.id
        //                 ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
        //                 : file // Leave other files unchanged
        //         )
        //     );
        // }

    };

    const findPrimary = selectedFeedback?.attachments?.filter((attachment) => attachment.primary == 1);
    const [highlightedFile, setHlightedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const handleImageClick = (file) => {
        setHlightedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setHlightedFile("");
    };

    return (
        <>
            <div className="">
                {/* {console.log('findPrimary', findPrimary)} */}
                {/* {console.log('recoveryAspects', recoveryAspects)}
                {console.log('selectedFeedback', selectedFeedback)} */}
                <Header />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <Link to='#' onClick={handleBack} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                            <div className='main_truck'>
                                {/* <div className='mb-3 mt-3 nestedtabs rounded'>

                                    <Stepper activeStep={activeStep} className="tracorder_step">
                                        {steps.map(({ label }, index) => (
                                            <Step key={index} disabled={index !== activeStep} className="">
                                                <StepLabel onClick={() => handleStepClick(index)}>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </div> */}
                                <div className="missing_info my-3">

                                    <div className='w-85 mx-auto'>
                                        <div className='text-center text_header mb-3'>
                                            <h3>Attachment or Messages</h3>
                                            <span>{recoveryDetails.station_handler_name} - {recoveryDetails.station_name}</span>
                                        </div>
                                        <Row>
                                            <Col sm='7' className='charter_from '>

                                                <div className='recover_middle'>
                                                    <Form.Group as={Row} className="mb-1">
                                                        <Col >
                                                            <Form.Label>Pieces Traced</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                placeholder=""
                                                                name='pieces_traced'
                                                                value={formData.pieces_traced || ''}
                                                                onChange={handleFormChange}
                                                            />
                                                        </Col>
                                                        <Col >
                                                            <Form.Label>Tracing Date </Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name='tracing_date'
                                                                value={formData.tracing_date || ''}
                                                                onChange={handleFormChange}

                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                    <div>
                                                        <Form.Label>Recovery Aspects </Form.Label>
                                                        <Form.Group as={Row} className="mb-1">
                                                            {recoveryAspects.map((aspect, index) => (
                                                                <React.Fragment key={index}>
                                                                    <Col className='mb-2'>
                                                                        <div className='warehose'>
                                                                            <Form.Check
                                                                                inline
                                                                                type="checkbox"
                                                                                id={`warehouseCheck${index}`}
                                                                                className="warehouse_check"
                                                                                label={`Warehouse Check - ${index + 1}`}
                                                                                checked={aspect.warehouse_check}
                                                                                onChange={(e) => handleInputChange(index, 'warehouse_check', e.target.checked)}
                                                                            />
                                                                            <Form.Control
                                                                                type="date"
                                                                                placeholder=""
                                                                                name="warehouse_check_date"
                                                                                value={aspect.warehouse_check_date}
                                                                                onChange={(e) => handleInputChange(index, 'warehouse_check_date', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col className='mb-2 position-relative'>
                                                                        <div className='warehose'>
                                                                            <Form.Check
                                                                                inline
                                                                                type="checkbox"
                                                                                id={`contactedAgent${index}`}
                                                                                className=""
                                                                                label={`Contacted Agent - ${index + 1}`}
                                                                                checked={aspect.contacted_agent}
                                                                                onChange={(e) => handleInputChange(index, 'contacted_agent', e.target.checked)}
                                                                            />
                                                                            <Form.Control
                                                                                type="date"
                                                                                placeholder=""
                                                                                name="contacted_agent_date"
                                                                                value={aspect.contacted_agent_date}
                                                                                onChange={(e) => handleInputChange(index, 'contacted_agent_date', e.target.value)}
                                                                            />
                                                                        </div>
                                                                        {recoveryAspects.length > 1 &&
                                                                            <Link to="#" onClick={() => handleRemoveAspect(index)} className='handler_trash'>
                                                                                <img src={Trash} />
                                                                            </Link>
                                                                        }
                                                                    </Col>
                                                                </React.Fragment>
                                                            ))}
                                                            <Col md="12">
                                                                <Button variant="outline-primary" className='more_btn mt-3' onClick={handleAddAspect}>
                                                                    Add More Aspects
                                                                </Button>
                                                            </Col>
                                                        </Form.Group>
                                                    </div>
                                                    <div>
                                                        <Form.Label>File Upload </Form.Label>
                                                        <div
                                                            className="dropfile "
                                                            onDrop={handleDrop}
                                                            onDragOver={handleDragOver}
                                                        >
                                                            <h3>Drag and drop files here</h3>
                                                            <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                                            <span>Maximum file size 4 MB</span>
                                                            <input
                                                                type="file"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleFileChange}
                                                                multiple
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex upimg_recover'>
                                                        {formData.attachments &&
                                                            <>

                                                                {formData?.attachments?.map((file, index) => {
                                                                    const fileName = file?.file_name;
                                                                    console.log("🚀 ~ {files.map ~ file:", file)
                                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                    const extension = fileName?.split(".").pop();
                                                                    return (
                                                                        <>
                                                                            {/* <div key={`ns_${index}`} className={`img-thumbnail ${file.primary === 1 ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}> */}
                                                                            {file.original_file_path == 'service_recovery_handler_feedback_edit_files' &&
                                                                                <>
                                                                                    <div key={`ns_${index}`} className='img-thumbnail'>
                                                                                        {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                        ) ? (
                                                                                            <>
                                                                                                <img
                                                                                                    src={file.file_path}
                                                                                                    alt="Preview"
                                                                                                    style={{
                                                                                                        maxWidth: "30px",
                                                                                                        maxHeight: "30px",
                                                                                                        marginRight: "10px",
                                                                                                    }}
                                                                                                // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                                // onClick={() =>
                                                                                                //   handleFileClick(file.file_path)
                                                                                                // }
                                                                                                />
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <span className="">
                                                                                                    <img src={Docmnt} className="fileimg" />
                                                                                                </span>
                                                                                            </>
                                                                                        )}
                                                                                        <span className="rafilename">
                                                                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                        </span>
                                                                                        {/* <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                                                                            <FontAwesomeIcon icon={faDownload} />
                                                                                        </Link> */}

                                                                                        {/* {1 === 1 && ( */}
                                                                                        {/* {file.is_comment !== 1 &&
                                                                                    file.is_editable === 1 && ( */}
                                                                                        <button
                                                                                            className="dltbtn"
                                                                                            type="button"
                                                                                            onClick={() =>
                                                                                                handleDeleteImage(index, file.id, file.attachment_type)
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faCircleXmark} />
                                                                                        </button>
                                                                                        {/* )} */}
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </>
                                                                    );
                                                                })}

                                                            </>
                                                        }
                                                        {files.map((file, index) => {
                                                            const fileName = file.name;
                                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                            // console.log("🚀 ~ {files.map ~ baseName:", baseName)
                                                            const extension = fileName?.split(".").pop();
                                                            return (
                                                                // <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                                <div key={index} className='img-thumbnail'>
                                                                    {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                                                    ) ? (
                                                                        <>
                                                                            <img
                                                                                src={URL.createObjectURL(file)}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "30px",
                                                                                    maxHeight: "30px",
                                                                                    marginRight: "5px",
                                                                                }}
                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                            // onClick={() => handleFileClick(file.file_path)}
                                                                            />
                                                                            <span>
                                                                                {/*file.file_name*/}
                                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span className="d-flex align-items-center">
                                                                                <img src={Docmnt} className="fileimg" />
                                                                                <span>{file.name}</span>
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                    {/* {file.type.startsWith('image/') ? (
                                                                            <img
                                                                                src={URL.createObjectURL(file)}
                                                                                alt="Preview"
                                                                                style={{ maxWidth: '40px', maxHeight: '40px', }}
                                                                            />
                                                                        ) : (
                                                                            <span className='d-flex'><img src={Docmnt} className='fileimg' />  </span>
                                                                        )} */}
                                                                    <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>

                                            </Col>
                                            <Col sm='5'>
                                                <div className=''>
                                                    <h4>Recovery Information</h4>
                                                    <ul>
                                                        <li>
                                                            <span>Master Airway Bill :</span> <span> {recoveryDetails?.master_airway_bill_prefix} - {recoveryDetails?.master_airway_bill_no}</span>
                                                        </li>
                                                        <li>
                                                            <span>Flight Number :</span> <span> {recoveryDetails?.flight_prefix} - {recoveryDetails?.flight_no}</span>
                                                        </li>
                                                        <li>
                                                            <span>Created Date :</span> <span> {recoveryDetails?.created_date}</span>
                                                        </li>
                                                        <li>
                                                            <span>Total MAWB Pieces :</span> <span> {recoveryDetails?.total_mawb_pieces}</span>
                                                        </li>
                                                        <li>
                                                            <span>Weight (Kg) :</span> <span> {recoveryDetails?.total_mawb_wght}</span>
                                                        </li>
                                                        <li>
                                                            <span>Pieces involved :</span> <span> {recoveryDetails?.pieces_involved}</span>
                                                        </li>
                                                        <li>
                                                            <span>Involved Weight (Kg) :</span> <span> {recoveryDetails?.pieces_wght}</span>
                                                        </li>
                                                        <li>
                                                            <span>Recovery Aspects :</span> <span> {recoveryDetails?.recovery_aspects_text}</span>
                                                        </li>
                                                    </ul>
                                                    <hr />
                                                    <div className='mb-3'>
                                                        <h4>Airline Highlighted Image(s)</h4>
                                                        {recoveryDetails?.attachments && (
                                                            <div className='main_primary mt-2'>
                                                                {findPrimary.map((file, index) => {
                                                                    const fileName = file?.file_name;
                                                                    // console.log("🚀 ~ {files.map ~ file:", file)
                                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                    const extension = fileName?.split(".").pop();
                                                                    return (
                                                                        <>
                                                                            <div key={`ns_${index}`} className='primary_image'>
                                                                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                ) ? (
                                                                                    <div>
                                                                                        <img
                                                                                            src={file.file_path}
                                                                                            alt="Preview"
                                                                                            style={{
                                                                                                maxWidth: "100%",
                                                                                                maxHeight: "100%",

                                                                                            }}
                                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                            onClick={() =>
                                                                                                handleImageClick(file.file_path)
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <>
                                                                                        <span className="">
                                                                                            <img src={Docmnt} className="fileimg" />
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                                <span className="rafilename">
                                                                                    {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                                                                                </span>
                                                                                {/* <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                                                                    <FontAwesomeIcon icon={faDownload} />
                                                                                </Link> */}

                                                                                {/* {1 === 1 && ( */}
                                                                                {/* {file.is_comment !== 1 &&
                                                                            file.is_editable === 1 && ( */}
                                                                                {/* <button
                                                                            className="dltbtn"
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleDeleteImage(index, file.id, file.attachment_type)
                                                                            }
                                                                        >
                                                                            <FontAwesomeIcon icon={faCircleXmark} />
                                                                        </button> */}
                                                                                {/* )} */}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className='ordernext'>

                                        <Button className='trnext' variant="contained" onClick={handleFinish}>
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                                <Modal show={imgShow} onHide={handleClose} centered className="imgmodal" size='lg'>
                                    <Modal.Header closeButton onClick={handleClose}></Modal.Header>
                                    <Modal.Body className='text-center'>
                                        {/* {console.log(selectedFile)} */}
                                        <img src={highlightedFile} className="img-fluid" alt="Selected" />

                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditHandlerRecovery;